import { MEETINGS_PAGE_LIMIT } from '@shared/constants/common';
import {
  genericMutation,
  genericMutationWithId,
  genericQueryWithId,
  genericQueryWithParams,
} from './generics';
import { enrollmentsApis, meetingsApis } from '@shared/apis';

export const useRescheduleMeeting = genericMutationWithId<meetingsApis.RescheduleMeeting>(
  meetingsApis.rescheduleMeeting,
  meetingsApis.searchMyMeetings.endpoint,
  meetingsApis.getMentorCalendarMeetings.endpoint,
  enrollmentsApis.searchSessionHistory.endpoint,
  enrollmentsApis.getActiveStudentsByMentor.endpoint,
  enrollmentsApis.searchMentorEnrollments.endpoint
);

export const useMyMeetings = genericQueryWithParams<meetingsApis.SearchMyMeetings>(
  meetingsApis.searchMyMeetings
);

export const useMentorStudentMeetings =
  genericQueryWithParams<meetingsApis.GetMentorStudentMeetings>(
    meetingsApis.getMentorStudentMeetings
  );

export const useFeedbackMeetings = (page?: number) => {
  return useMyMeetings(
    {
      page,
      status: 'feedback',
      limit: MEETINGS_PAGE_LIMIT,
    },
    { refetchInterval: 5000 }
  );
};

export const useUpcomingMeetings = (page?: number) => {
  return useMyMeetings(
    { page, status: 'upcoming', limit: MEETINGS_PAGE_LIMIT },
    { refetchInterval: 5000 }
  );
};

export const useOngoingMeetings = () => {
  return useMyMeetings(
    {
      status: 'started',
    },
    { refetchInterval: 5000 }
  );
};

export const useMeeting = genericQueryWithId<meetingsApis.GetMeeting>(meetingsApis.getMeeting);

export const useGetMeetingRecordings = genericQueryWithId<meetingsApis.GetMeetingRecordings>(
  meetingsApis.getMeetingRecordings
);

export const useGetAIGeneratedFeedback = genericQueryWithId<meetingsApis.GetAIGeneratedFeedback>(
  meetingsApis.getAIGeneratedFeedback
);

export const useRegisterMentorFeedback = genericMutationWithId<meetingsApis.RegisterMentorFeedback>(
  meetingsApis.registerMentorFeedback,
  meetingsApis.searchMyMeetings.endpoint,
  enrollmentsApis.searchSessionHistory.endpoint,
  meetingsApis.noOfCompletedSessionsCurrentMonth.endpoint
);

export const useCalculateMeetingBillableTime =
  genericQueryWithId<meetingsApis.CalculateMeetingBillableTime>(
    meetingsApis.calculateMeetingBillableTime
  );

export const useRegisterStudentFeedback =
  genericMutationWithId<meetingsApis.RegisterStudentFeedback>(
    meetingsApis.registerStudentFeedback,
    meetingsApis.searchMyMeetings.endpoint,
    enrollmentsApis.searchSessionHistory.endpoint
  );

export const useUpdateMeeting = genericMutationWithId<meetingsApis.UpdateMeeting>(
  meetingsApis.updateMeeting,
  meetingsApis.getMeeting.endpoint,
  meetingsApis.getMentorCalendarMeetings.endpoint,
  enrollmentsApis.searchSessionHistory.endpoint,
  enrollmentsApis.getActiveStudentsByMentor.endpoint,
  enrollmentsApis.searchMentorEnrollments.endpoint
);

export const useUpdateMeetingStatus = genericMutationWithId<meetingsApis.UpdateMeetingStatus>(
  meetingsApis.updateMeetingStatus,
  meetingsApis.getMeeting.endpoint,
  meetingsApis.searchMyMeetings.endpoint,
  '/enrollments/:id'
);

export const useCreateMeeting = genericMutation<meetingsApis.CreateMeeting>(
  meetingsApis.createMeeting,
  enrollmentsApis.getSessionDetails.endpoint,
  enrollmentsApis.searchMentorEnrollments.endpoint,
  enrollmentsApis.getActiveStudentsByMentor.endpoint,
  meetingsApis.getMentorCalendarMeetings.endpoint
);

export const useMentorSessionNo =
  genericQueryWithId<meetingsApis.NoOfCompletedSessionsCurrentMonth>(
    meetingsApis.noOfCompletedSessionsCurrentMonth
  );

export const useGetMeetingNotes = genericQueryWithId<meetingsApis.GetMeetingNotes>(
  meetingsApis.getMeetingNotes
);

export const useUpdateMeetingNotes = genericMutationWithId<meetingsApis.UpdateMeetingNotes>(
  meetingsApis.updateMeetingNotes,
  meetingsApis.getMeetingNotes.endpoint,
  enrollmentsApis.getSessionDetails.endpoint
);

export const useGetMentorCalendarMeetings =
  genericQueryWithParams<meetingsApis.GetMentorCalendarMeetings>(
    meetingsApis.getMentorCalendarMeetings
  );

export const useSaveBillableTimeReason = genericMutationWithId<meetingsApis.SaveBillableTimeReason>(
  meetingsApis.saveBillableTimeReason,
  meetingsApis.getMeeting.endpoint,
  enrollmentsApis.getSessionDetails.endpoint
);
